import { z } from 'zod'

export const dividendCouponRowSchema = z.object({
  kind: z.enum(['dividend', 'coupon']),
  date: z.string(),
  amount: z.number(),
  currency: z.string(),
  // per-event dividend yield as a percent (T-Bank yieldValue); null for coupons and when absent
  yieldValue: z.number().nullable(),
})
export type DividendCouponRowDto = z.infer<typeof dividendCouponRowSchema>

export const instrumentExtrasSchema = z.object({
  marketCap: z.number().nullable(),
  peRatio: z.number().nullable(),
  dividendYield: z.number().nullable(),
  high52Weeks: z.number().nullable(),
  low52Weeks: z.number().nullable(),
  schedule: z.array(dividendCouponRowSchema),
})
export type InstrumentExtrasDto = z.infer<typeof instrumentExtrasSchema>
